<template>
  <div class="filtrateOpsItem">
    <el-dropdown class="dropdown" trigger="click" :hide-on-click="false" :disabled="list.length == 0">
      <div class="header-icon">
        <img src="@/assets/select-icon.png" />
      </div>
      <template #dropdown >
        <el-dropdown-menu>
          <!-- dataList  item[identifyTitle]  v-model="item.isSelected"-->
          <el-dropdown-item
            v-for="(item, index) in list"
            class="dropdown-item"
            :command="item"
            :key="index"
            :disabled="false"
            ><el-checkbox @change="checkBoxSelect(item)" v-model="item.isSelected">{{ item[identifyTitle] }}</el-checkbox></el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  name: "filtrateOpsItem",
  props: {
    identifyTitle: {
      default: "",
      type: String,
    },
    dataList: {
      default: () => [],
      type: Array,
    }
  },
  data() {
    return {
    };
  },
  methods: {
    checkBoxSelect(item) {
      this.$emit("checkBoxSelect", {item: item, identifyTitle: this.identifyTitle, selectTitle: item[this.identifyTitle]})
    }
  },
  computed: {

    list() {
      const ll = []
      for (const item of this.dataList) {
        const have = ll.some(m => {
          return m[this.identifyTitle] == item[this.identifyTitle]
        })
        if (!have) {
          ll.push(item)
        }
      }
      return ll
    },

    testList() {

      

      const ll = []
      for (const item of this.dataList) {
        const l =  item[this.identifyTitle]
        ll.push(l)
      }
      return [... new Set(ll)];
    }
  },
  created() {},
};
</script>
<style lang='less' scoped>

.filtrateOpsItem {
  height: 100%;
  display: flex;
  align-items: center;
}
.header-icon {
  height: 14px;
  width: 14px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.el-dropdown-menu {
  max-height: 400px !important;
}
</style>